import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";

class Deferred {
  promise: Promise<any>;
  resolve!: (value?: any) => void;
  reject!: (reason?: any) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

const createFaqSlice = (set: (data: any) => void, get: () => any) => ({
  createFaq: (payload: any) => {
    if (payload.isfaqof === undefined) {
      throw new Error();
    }

    if (payload.lang === undefined) {
      payload.lang = get().lang;
    }

    if (payload.nodeid === undefined) {
      payload.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
    }

    if (payload.usernodeid === undefined) {
      payload.usernodeid = get().userNodeId;
    }

    const commandObjects = [];
    const attachmentCommandObjects = [];

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.nodeid,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          title: attachment.title,
          description: attachment.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.nodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    delete payload.attachments;

    const faqCommandObject = {
      parentNodeIds: [payload.equipmentnodeid],
      nodeId: payload.nodeid,
      payload: payload,
      type: "create",
      task: "processCreateFaqCommand",
    };

    commandObjects.push(faqCommandObject, ...attachmentCommandObjects);
    const promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  updateFaq: async (payload: any) => {
    const commandObjects = [];
    const attachmentCommandObjects = [];
    let promises;

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.nodeid,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          title: attachment.title,
          description: attachment.description,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.nodeid],
          nodeid: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    delete payload.attachments;

    const updatedCommandObject = {
      parentNodeIds: [payload.isfaqof],
      nodeId: payload.nodeid,
      payload: payload,
      type: "update",
      task: "processUpdateFaqCommand",
    };
    commandObjects.push(updatedCommandObject, ...attachmentCommandObjects);

    promises = get().enqueueCommands(commandObjects);

    return promises;
  },

  deleteFaq: async (nodeId: string, faqOfNodeId: string) => {
    let promises;
    const payload: any = {};
    payload.nodeid = nodeId;
    const deleteCommandObject = {
      parentNodeIds: [faqOfNodeId],
      nodeId: nodeId,
      payload: payload,
      type: "delete",
      task: "processDeleteFaqCommand",
    };
    promises = get().enqueueCommands([deleteCommandObject]);

    //the command was not yet sent to the server
    const promise = new Deferred();
    promise.resolve();
    promises = [promise];

    return promises;
  },

  processCreateFaqCommand: async (commandObject: any) => {
    try {
     

      if (get().isLoggedIn === true) {
        const response = await Axios.post(
          "api/v1/faqs",
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 10000,
          }
        );

        const a = 10;

        if (response && response?.status == 200) {
         
          return response.data;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
     
      throw new Error(error as string);
    }
  },

  processUpdateFaqCommand: async (commandObject: any) => {
    try {
    
      if (get().isLoggedIn === true) {
        const encodedFaqNodeId = encodeURIComponent(
          commandObject.payload.questionanswernodeid
        );
        const response = await Axios.put(
          "/api/v1/faqs/" + encodedFaqNodeId,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
             
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
         
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  processDeleteFaqCommand: async (commandObject: any) => {
    try {
     

      if (get().isLoggedIn === true) {
        const encodedFaqNodeId = encodeURIComponent(
          commandObject.payload.nodeid
        );

        const response = await Axios.delete(
          "/api/v1/faqs/" + encodedFaqNodeId,
          {
            headers: {
              "Content-Type": "application/json",
           
            },
            timeout: 10000,
          }
        );

        if (response && response?.status == 200) {
          
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(error as string);
    }
  },

  createNewFaqObject: (
    faqCommandObject: any,
    attachmentCommandObjects: any,
    user: any
  ) => {
    const faq = _.cloneDeep(faqCommandObject.payload);
    faq.isfaqof = [{ equipment: { nodeid: faqCommandObject.payload.isfaqof } }];

    faq.hasauthor = [{ user: user }];

    const attachments = [];

    if (attachmentCommandObjects?.length > 0) {
      for (const attachmentCommandObject of attachmentCommandObjects) {
        attachments.push({
          attachment: get().createNewAttachmentObject(attachmentCommandObject),
        });
      }
      faq.hasattachment = attachments;
    }
    return faq;
  },
});

export default createFaqSlice;
